import { render, staticRenderFns } from "./DefaultAccountsPage.vue?vue&type=template&id=d8bae250"
import script from "./DefaultAccountsPage.vue?vue&type=script&lang=js"
export * from "./DefaultAccountsPage.vue?vue&type=script&lang=js"
import style0 from "./DefaultAccountsPage.vue?vue&type=style&index=0&id=d8bae250&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports